import React from "react";
import AdditionalPolicyLayout from "./aditional-policy-layout";

export default class AdditionalPolicy extends React.Component<{}, {}> {
  render() {
    return <AdditionalPolicyLayout />;
  }
}
